import ActionType from "../actions/ActionType"
import { IAction } from "../actions/Action"
import { INotification } from "../components/mike-notification-list";

export interface INotificationState {
  notification: INotification[];
}

const initState = { 
  notification: Array<INotification>()
}

const notification = (state = initState, action: IAction) => {
  switch (action.type) {
    case ActionType.SET_NOTIFICATION:
      return {
        ...state,
        notification: action.data      
      };      
    default:
        return state;
  }
};

export default notification
